import { useEffect, useRef } from 'react';
import scroll from 'utilities/scroll';

export const useSectionScroll = isCollapsed => {
    const sectionRef = useRef();
    const isMountedRef = useRef(false);
    useEffect(() => {
        if (!isCollapsed && isMountedRef.current && sectionRef.current) {
            scroll.transition(sectionRef.current, 'top', 1, 0, -30);
        }
        isMountedRef.current = true;
    }, [isCollapsed]);

    return sectionRef;
};
